module.exports = __webpack_public_path__ + "img/51.6d8230ea.png";